// extracted by mini-css-extract-plugin
export var closeButton = "_i3-2";
export var closeButtonIcon = "_i3-3";
export var lightboxContent = "_i3-1";
export var lightboxOverlay = "_i3-0";